<mat-card>
  <mat-panel-title>
    <title mat-dialog-title>{{ 'cameras.clip.title' | t }}</title>
  </mat-panel-title>
  <form snDrawer [formGroup]="form">
    <div class="clip">
      <sn-form [form]="form" [fields]="formFields" [(model)]="formModel"> </sn-form>
    </div>

    <ng-container *ngIf="!clipLoading">
      <button
        mat-button
        color="success"
        class="queue-play-next"
        type="button"
        (click)="addToVault(camera.id)"
        [disabled]="form.invalid || exportDisabled"
      >
        <sn-icon>queue_play_next</sn-icon> {{ 'cameras.clip.addToVault' | t }}
      </button>
    </ng-container>
    <fs-download-video
      *ngIf="!data.camera.isFususCamera"
      class="fs-download"
      [data]="{startTime: formModel.start, endTime: formModel.end}"
      [camera]="camera"
      [isLocal]="isLocal"
      (loadingInProgress)="getProgress($event)"
      [invalid]="form.invalid || exportDisabled || !canDownload"
    >
    </fs-download-video>
  </form>
  <mat-dialog-actions>
    <button mat-button class="close-button" (click)="close()">{{ 'common.close' | t }}</button>
  </mat-dialog-actions>
</mat-card>
